import _ from '../../common/utility'

function setHeaderBackground() {
    const headerBackground = $('header').attr('data-header-background');
    const bucket2col = $(".hp_bucket2col").first();
    if(headerBackground) {
        $('head').append(`<style>.cc.resp-container::before{background-image: url(${headerBackground})}</style>`);
    }
}

export default _.catch(setHeaderBackground);